import React from 'react';
export const OptimiseCharge = React.lazy(() => import('./OptimiseCharge.jsx'));
